import React from 'react';
import { useSelector } from 'react-redux';

import { BrandAmbassadorPhoto } from 'app/components/BrandAmbassadorPhoto';
import { BrandAmbassadorRecommendation } from 'app/components/BrandAmbassadorRecommendation';
import { BrandAmbassadorSymbolProps } from './BrandAmbassadorSymbol.interface';
import { useStyles } from './BrandAmbassadorSymbol.styles';
import { selectIsFormMicroCenterActive } from 'app/store/selectors/selectIsFormMicroCenterActive';

export default function BrandAmbassadorSymbol(
  props: BrandAmbassadorSymbolProps
) {
  const isFormMicroCenterActive = useSelector(selectIsFormMicroCenterActive);
  const classes = useStyles({ isFormMicroCenterActive })();

  return (
    <div className={classes.container}>
      <BrandAmbassadorRecommendation className={classes.recommendationSign} />
      <BrandAmbassadorPhoto className={classes.photo} />
    </div>
  );
}
